import React, { useEffect } from 'react';
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import ComprehensiveFrameworkView from './ComprehensiveFrameworkView';
import './ComplianceMapping.css';

const ComplianceMapping = (props) => {
  document.title = "Compliance Mapping | GOVCOM";

  useEffect(() => {
    props.setBreadcrumbItems('Compliance Mapping', []);
  }, []);

  return (
    <div className="compliance-mapping-page">
      <ComprehensiveFrameworkView />
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(ComplianceMapping);
